module.exports = __webpack_public_path__ + "img/icon-play.901b2618.svg";